module.exports = "images/service_icon_02.svg";